<script>
import chiefRoleOptions from '../../../common/data/chiefRoleOptions.json'
import chiefAuditorRoleOptions from '../../../common/data/chiefAuditorRoleOptions.json'

export default {
    data() {
        return {
            chiefRoleOptions,
            chiefAuditorRoleOptions,
            formChiefRole: null,
        }
    },

    methods: {
        findChiefRecord() {
            if (!this.showChiefRole || !this.client || !this.personId) {
                return null
            }

            const collection =
                this.effectiveLinkType === 'auditors'
                    ? this.client.auditors?.data
                    : this.client.chiefs?.data

            if (!collection) {
                return null
            }

            const personType = this.personType || 'physical'

            return collection.find((chief) => {
                if (personType === 'physical') {
                    return (
                        chief.chief_type === 'physical' &&
                        chief.chief_data?.id == this.personId
                    )
                }

                return (
                    chief.chief_type === 'moral' &&
                    chief.chief_data?.id == this.personId
                )
            })
        },

        initChiefRoleFromRecord() {
            const chief = this.findChiefRecord()
            this.formChiefRole = chief?.chief_role ?? null
        },

        async updateChiefRole() {
            const chief = this.findChiefRecord()
            if (!chief?.id || !this.formChiefRole) {
                return
            }

            await axios.put(`/chiefs/${chief.id}`, {
                role: this.formChiefRole,
            })
        },

        appendRoleToPayload(payload) {
            if (this.showChiefRole && this.formChiefRole) {
                payload.role = this.formChiefRole
            }

            return payload
        },
    },

    computed: {
        effectiveLinkType() {
            return this.linkType || this.personType || ''
        },

        showChiefRole() {
            return (
                this.effectiveLinkType === 'chiefs' ||
                this.effectiveLinkType === 'auditors'
            )
        },

        chiefRecord() {
            return this.findChiefRecord()
        },

        chiefRoleSelectOptions() {
            const base = [{ value: null, text: 'Qualité' }]

            if (this.effectiveLinkType === 'auditors') {
                return base.concat(this.chiefAuditorRoleOptions)
            }

            return base.concat(this.chiefRoleOptions)
        },

        roleRequired() {
            return ['auditors', 'chiefs'].includes(this.effectiveLinkType)
        },

        chiefRoleIsInvalid() {
            if (!this.showChiefRole || !this.roleRequired) return false

            return this.formChiefRole === null || this.formChiefRole === ''
        },
    },
}
</script>
